import { Dialog, DialogTitle } from "@mui/material";
import { ReactElement } from "react";

import { TagGroupDetail } from "~frontend/graphql/tags";

import EditTagGroupForm from "./EditTagGroupForm";
import {
  EditTagGroupFormType,
  NgpVanIntegration,
  tagIntegrationsToFormValues,
} from "./types";

export default function EditTagGroupDialog({
  open,
  onClose,
  onSave,
  vanIntegrations,
  tagGroup,
  allTagNames,
}: {
  open: boolean;
  onClose: () => void;
  onSave: (formData: EditTagGroupFormType) => Promise<void>;
  vanIntegrations: NgpVanIntegration[];
  tagGroup: TagGroupDetail;
  allTagNames: string[];
}): ReactElement {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Tag</DialogTitle>
      <EditTagGroupForm
        initialName={tagGroup.name}
        initialTags={tagGroup.tags.map(tag => ({
          id: tag.id,
          name: tag.name,
          integrations: tagIntegrationsToFormValues(tag.integrationActions),
        }))}
        onSave={onSave}
        onCancelClick={onClose}
        vanIntegrations={vanIntegrations}
        allOtherTagNames={allTagNames.filter(name => name !== tagGroup.name)}
      />
    </Dialog>
  );
}
